import React from 'react';
import SubLayout from '../../components/Layout/SubLayout'
import strings from '../../components/Language';
import "./profile.scss"
import _ from 'lodash';
import Avatar1 from './../../assets/images/icons/avatar1.svg'
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import moment from 'moment';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import $ from 'jquery';

class ProfileInfoScreen extends React.Component {

    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            access_token: "",
            user_data: {},
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            this.setState({ access_token: token });
            setTimeout(() => {
                this.getData();
            });
        }
    }

    getData() {
        const { setLoading } = this.context;
        setLoading(true);
        var self = this;

        axios({
            method: 'GET',
            url: api.profile_show,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
                'Accept-Language': strings.getLanguage(),
            }
        }).then(function (ress) {
            if (ress.data && ress.data.error === 200) {

                var data = ress.data.data;
                if (data.expired_at_data && data.expired_at_data.expired_at) {
                    var date1 = moment();
                    var expired_at = moment(data.expired_at_data.expired_at);
                    data.expired_at_data.expired_days = expired_at.diff(date1, 'days')
                }

                self.setState({ user_data: data });
            } else {
                if (ress.data.validation && ress.data.validation.length !== 0) {
                    _.forEach(ress.data.validation, function (value) {
                        if (value[0]) {
                            toast.error(value[0]);
                        }
                    });
                } else {
                    toast.error(ress.data.message);
                }
            }
            setTimeout(() => {
                setLoading(false);
            });
        }).catch(function () {
            setLoading(false);
        });
    };

    handleFileSelect = (event) => {
        const { setLoading } = this.context;
        setLoading(true);
        const self = this;

        var selectedFile = event.target.files[0]

        event.preventDefault()
        const formData = new FormData();
        formData.append("avatar", selectedFile);

        axios({
            method: 'POST',
            url: api.profile_update_avatar,
            data: formData,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                "Content-Type": "multipart/form-data",
                'Accept-Language': strings.getLanguage(),
            }
        }).then(function (ress) {
            if (ress.data && ress.data.error === 200) {
                setLoading(false);
                toast.success(ress.data.message);
                self.getData();
            } else {
                if (ress.data.validation && ress.data.validation.length !== 0) {

                    _.forEach(ress.data.validation, function (value) {
                        if (value[0]) {
                            toast.error(value[0]);
                        }
                    });
                } else {
                    toast.error(ress.data.message);
                }
                setLoading(false);
            }
            setLoading(false);
        }).catch(function () {
            setLoading(false);
        });
    }

    confirmActivation() {
        let self = this;
        $.confirm({
            title: strings.confirm + '!',
            theme: 'dark',
            content: strings.are_you_sure_you + "?",
            buttons: {
                somethingElse: {
                    text: "Yes",
                    btnClass: 'btn-success',
                    action: function () {
                        self.activeProfile()
                    }
                },
                cancel: function () {
                },
            }
        });
    };

    activeProfile() {
        const { setLoading } = this.context;
        setLoading(true);
        const self = this;
        axios({
            method: 'POST',
            url: api.profile_activate,
            data: {},
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
                'Accept-Language': strings.getLanguage(),
            }
        }).then(function (ress) {
            if (ress.data && ress.data.error === 200) {
                setLoading(false);
                toast.success(ress.data.message);
                self.getData();
            } else {
                if (ress.data.validation && ress.data.validation.length !== 0) {
                    _.forEach(ress.data.validation, function (value) {
                        if (value[0]) {
                            toast.error(value[0]);
                        }
                    });
                } else {
                    toast.error(ress.data.message);
                }
                setLoading(false);
            }
            setLoading(false);
        }).catch(function () {
            setLoading(false);
        });
    }

    render() {
        const userData = this.state.user_data || {};
        const infoRows = [
            { key: 'username', label: strings.username, value: userData.name || '-' },
            { key: 'email', label: strings.email, value: userData.email || '-' },
            { key: 'id', label: strings.id, value: userData.username || '-' },
            { key: 'inviter', label: strings.my_inviter_id, value: userData.invitation_code || '-' },
            {
                key: 'level',
                label: strings.level,
                value: (userData.level_data && userData.level_data.name) ? userData.level_data.name : '-',
                className: (userData.level_data && userData.level_data.class) ? userData.level_data.class : ''
            },
            {
                key: 'status',
                label: strings.status,
                value: (userData.status_data && userData.status_data.name) ? userData.status_data.name : '-',
                className: (userData.status_data && userData.status_data.class) ? userData.status_data.class : ''
            },
        ];

        return (
            <SubLayout data={{ "title": strings.profile_information }}>
                <div className="profile-subpage">
                    <label className="profile-info-avatar-row" htmlFor="files">
                        <div className='profile-list-left'>
                            <img className='profile-info-avatar' src={(userData && userData.avatar_url) ? userData.avatar_url : Avatar1} alt="avatar"></img>
                            <span>{strings.change_avatar}</span>
                        </div>
                    </label>
                    <input id="files" style={{ visibility: "hidden", display: "none" }} type="file" onChange={this.handleFileSelect} placeholder={strings.change_profile_image} />

                    <div className='profile-panel' style={{ marginTop: 12 }}>
                        {infoRows.map((row) => (
                            <div key={row.key} className='profile-list-item'>
                                <div className='profile-list-left'>
                                    <span>{row.label}: </span>
                                    <span className={row.className || ''}>{row.value}</span>
                                </div>
                            </div>
                        ))}
                        <div className='profile-list-item'>
                            <div className='profile-list-left'>
                                <span>{strings.subscription}: {(userData && userData.expired_at_data && userData.expired_at_data.expired_at) ? userData.expired_at_data.expired_at : "-"}</span>
                            </div>
                            <button onClick={() => this.confirmActivation()} className={'profile-inline-action'} style={{ maxWidth: 170 }}>
                                {(userData && userData.status) ? strings.extend_subscription : strings.active}
                            </button>
                        </div>
                    </div>
                </div>
            </SubLayout >
        );
    }
}

export default ProfileInfoScreen;
